import React from "react";
import { Container, Grid, Typography, Button } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { makeStyles } from "@mui/styles";
import IconButton from "@mui/material/IconButton";
import { BsGithub } from "react-icons/bs";

const useStyles = makeStyles(() => {
  return {
    typoCasestudyfont1: {
      fontFamily: "Rubik",
      fontWeight: 500,
      color: "black",
      //   fontSize: 18,
    },
    typoCasestudyfont2: {
      fontFamily: "Rubik",
      fontWeight: 300,
      color: "#757575",
      //   fontSize: 18,
    },
    typoText: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 300,
      textAlign: "center",
      //   fontSize: 18,
    },
    typoTextRight: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 300,
      //   fontSize: 18,
      textAlign: "right",
    },
    typoHeadline: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 700,
    },
    typoSubheadline: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 500,
    },
    image: {
      "&:hover": {
        opacity: "0.5",
        transition: "ease-in-out",
        transitionDuration: "0.2s",
      },
    },
    but: {
      fontSize: 20,
    },
  };
});

const Section5 = () => {
  const classes = useStyles();

  return (
    <>
      <Container
        sx={{ paddingTop: 20 }}
        id="letsconnect"
        data-aos="fade-up"
        data-aos-offset="250"
        data-aos-duration="800"
      >
        <Grid container justifyContent="center">
          <Grid item>
            <Card sx={{ maxWidth: 480 }} elevation={0}>
              <CardContent>
                <Typography variant="h6" className={classes.typoText}>
                  Schedule a meeting and discuss your project and ideas and we
                  can surely come up with promising results
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item>
            <Card sx={{ maxWidth: 600 }} elevation={0}>
              <CardContent>
                <img src="meeting.png" width="100%" height="100%" />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item>
            <Card sx={{ maxWidth: 400 }} elevation={0}>
              <CardContent>
                <Button size="large" href="mailto:musabshaikh172@gmail.com">
                  <img
                    src="email.svg"
                    width="100%"
                    height="100%"
                    style={{ boxShadow: "2px 2px 8px 3px #E8ECFF" }}
                  />
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item>
            <Card sx={{ maxWidth: 350 }} elevation={0}>
              <CardContent>
                <IconButton
                  size="large"
                  onClick={() =>
                    window.open(
                      "https://www.linkedin.com/in/musab-shaikh-42221a213/"
                    )
                  }
                >
                  <img
                    src="linkedin.svg"
                    width="100%"
                    height="100%"
                    style={{
                      boxShadow: "2px 2px 8px 3px #E8ECFF",
                      borderRadius: "45%",
                    }}
                  />
                </IconButton>
              </CardContent>
            </Card>
          </Grid>
          <Grid item>
            <Card sx={{ maxWidth: 350 }} elevation={0}>
              <CardContent>
                <IconButton
                  size="large"
                  onClick={() => window.open("https://github.com/MusabShk")}
                >
                  <img
                    src="github.svg"
                    width="100%"
                    height="100%"
                    style={{
                      boxShadow: "2px 2px 8px 3px #E8ECFF",
                      borderRadius: "45%",
                    }}
                  />
                </IconButton>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Section5;
